export default {
  title: 'Minimaal betalingsbedrag: Betalingen kunnen niet tussen {{rangeStart}} - {{rangeEnd}} liggen',
  description: 'Uitzondering: Als je een gratis artikel hebt, kun je afrekenen met een totaal van {{amount}}.',
};
